'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const ShoppingCartIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.81299 3.75H4.93048C5.42178 3.75 5.8403 4.10688 5.91792 4.59201L6.2632 6.75M6.2632 6.75L7.64848 15.408C7.7261 15.8931 8.14462 16.25 8.63592 16.25H18.8367C19.3288 16.25 19.7477 15.892 19.8245 15.406L21.1869 6.75H6.2632Z",
          stroke: "currentColor",
          strokeLinecap: "square"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M10.2832 19.75C10.2832 20.3023 9.83548 20.75 9.2832 20.75C8.73092 20.75 8.2832 20.3023 8.2832 19.75C8.2832 19.1977 8.73092 18.75 9.2832 18.75C9.83548 18.75 10.2832 19.1977 10.2832 19.75Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M19.2832 19.75C19.2832 20.3023 18.8355 20.75 18.2832 20.75C17.7309 20.75 17.2832 20.3023 17.2832 19.75C17.2832 19.1977 17.7309 18.75 18.2832 18.75C18.8355 18.75 19.2832 19.1977 19.2832 19.75Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.5332 19.75C10.5332 20.4404 9.97356 21 9.2832 21C8.59284 21 8.0332 20.4404 8.0332 19.75C8.0332 19.0596 8.59284 18.5 9.2832 18.5C9.97356 18.5 10.5332 19.0596 10.5332 19.75ZM19.5332 19.75C19.5332 20.4404 18.9736 21 18.2832 21C17.5928 21 17.0332 20.4404 17.0332 19.75C17.0332 19.0596 17.5928 18.5 18.2832 18.5C18.9736 18.5 19.5332 19.0596 19.5332 19.75ZM9.2832 20.75C9.83548 20.75 10.2832 20.3023 10.2832 19.75C10.2832 19.1977 9.83548 18.75 9.2832 18.75C8.73092 18.75 8.2832 19.1977 8.2832 19.75C8.2832 20.3023 8.73092 20.75 9.2832 20.75ZM18.2832 20.75C18.8355 20.75 19.2832 20.3023 19.2832 19.75C19.2832 19.1977 18.8355 18.75 18.2832 18.75C17.7309 18.75 17.2832 19.1977 17.2832 19.75C17.2832 20.3023 17.7309 20.75 18.2832 20.75Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
const VpShoppingCartIcon = forwardRef(ShoppingCartIcon);

export { VpShoppingCartIcon as default };
